export const SECURITY_AUTH0_DOMAIN = 'dougapp.auth0.com'
export const SECURITY_AUTH0_CLIENTID = '9EymvWGsD6wELM6n1jt0DzQTqFKBrsm1'
// export const SECURITY_AUTH0_CLIENTID = 'xAP4AVMUborYqvA9F3HyB7IoeBqLP1GM' // nueva app de dougvet
export const SECURITY_AUTH0_REDIRECTURI = 'http://localhost:3000/callback'
export const SECURITY_AUTH0_AUDIENCE = 'https://api.dougapp.com'
export const SECURITY_AUTH0_RESPONSETYPE = 'token id_token'
export const SECURITY_ENABLED = true



// WEBPACK FOOTER //
// ./src/config/security.dev.js